import { useRef, useState } from 'react';
import { useMouse, useWindowSize } from 'react-use';
import styled from 'styled-components';

import { ProductFavorite, DesktopZoomImage } from '@components/products';

const ProductCarousel = ({ product, toggleZoom, isZoomed }) => {
    const carouselRef = useRef(null);
    const nextImageWrapperRef = useRef(null);

    const { docX, docY } = useMouse(carouselRef);
    const { width } = useWindowSize();

    const [zoomImg, setZoomImg] = useState(null);

    return (
        <CarouselWrapper ref={carouselRef}>
            <ProductFavorite product={product} forDesktop />
            <DesktopZoomImage
                isZoomed={width > 1024 && isZoomed}
                mousePosition={{ x: docX, y: docY }}
                zoomImg={zoomImg}
                toggleZoom={() => {
                    toggleZoom();
                    setZoomImg(null);
                }}
            />
            {product.images?.map((image, idx) => (
                <NextImageWrapper
                    id={idx}
                    key={idx} // eslint-disable-line
                    ref={nextImageWrapperRef}
                    onClick={() => {
                        toggleZoom();
                        setZoomImg(image?.urls?.original);
                    }}
                >
                    <img src={image?.urls?.original} alt={product.name.en} />
                </NextImageWrapper>
            ))}
        </CarouselWrapper>
    );
};

const CarouselWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    position: relative;

    @media (max-width: 1024px) {
        display: none;
    }
`;

const NextImageWrapper = styled.div`
    cursor: url('/zoomOpenCursor.svg'), auto;
    width: 100%;
    position: relative;

    img {
        width: 100%;
        object-fit: cover;
        display: block;
    }
`;
export default ProductCarousel;
